module.exports = __webpack_public_path__ + "static/media/lobby.17877106.JPG";